/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as CoachRouteRouteImport } from './routes/coach/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SellerRouteRouteImport } from './routes/seller/route'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminProcessingRouteImport } from './routes/admin/processing'
import { Route as AdminStoresRouteImport } from './routes/admin/stores'
import { Route as AdminSystemPromptRouteImport } from './routes/admin/system-prompt'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as CoachIndexRouteImport } from './routes/coach/index'
import { Route as CoachSystemPromptRouteImport } from './routes/coach/system-prompt'
import { Route as SellerIndexRouteImport } from './routes/seller/index'
import { Route as SellerAnalyticsRouteImport } from './routes/seller/analytics'
import { Route as SellerGuideRouteImport } from './routes/seller/guide'
import { Route as SellerUploadRouteImport } from './routes/seller/upload'
import { Route as CoachConsultationsIdRouteImport } from './routes/coach/consultations.$id'
import { Route as CoachSellersIdRouteImport } from './routes/coach/sellers.$id'
import { Route as CoachStoresIndexRouteImport } from './routes/coach/stores/index'
import { Route as CoachStoresIdRouteImport } from './routes/coach/stores/$id'
import { Route as SellerConsultationsIdRouteImport } from './routes/seller/consultations.$id'
import { Route as SellerDashboardIndexRouteImport } from './routes/seller/dashboard/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const CoachRouteRoute = CoachRouteRouteImport.update({
  id: '/coach',
  path: '/coach',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SellerRouteRoute = SellerRouteRouteImport.update({
  id: '/seller',
  path: '/seller',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProcessingRoute = AdminProcessingRouteImport.update({
  id: '/processing',
  path: '/processing',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminStoresRoute = AdminStoresRouteImport.update({
  id: '/stores',
  path: '/stores',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSystemPromptRoute = AdminSystemPromptRouteImport.update({
  id: '/system-prompt',
  path: '/system-prompt',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const CoachIndexRoute = CoachIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CoachRouteRoute,
} as any)
const CoachSystemPromptRoute = CoachSystemPromptRouteImport.update({
  id: '/system-prompt',
  path: '/system-prompt',
  getParentRoute: () => CoachRouteRoute,
} as any)
const SellerIndexRoute = SellerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SellerRouteRoute,
} as any)
const SellerAnalyticsRoute = SellerAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => SellerRouteRoute,
} as any)
const SellerGuideRoute = SellerGuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => SellerRouteRoute,
} as any)
const SellerUploadRoute = SellerUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => SellerRouteRoute,
} as any)
const CoachConsultationsIdRoute = CoachConsultationsIdRouteImport.update({
  id: '/consultations/$id',
  path: '/consultations/$id',
  getParentRoute: () => CoachRouteRoute,
} as any)
const CoachSellersIdRoute = CoachSellersIdRouteImport.update({
  id: '/sellers/$id',
  path: '/sellers/$id',
  getParentRoute: () => CoachRouteRoute,
} as any)
const CoachStoresIndexRoute = CoachStoresIndexRouteImport.update({
  id: '/stores/',
  path: '/stores/',
  getParentRoute: () => CoachRouteRoute,
} as any)
const CoachStoresIdRoute = CoachStoresIdRouteImport.update({
  id: '/stores/$id',
  path: '/stores/$id',
  getParentRoute: () => CoachRouteRoute,
} as any)
const SellerConsultationsIdRoute = SellerConsultationsIdRouteImport.update({
  id: '/consultations/$id',
  path: '/consultations/$id',
  getParentRoute: () => SellerRouteRoute,
} as any)
const SellerDashboardIndexRoute = SellerDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => SellerRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/coach': typeof CoachRouteRouteWithChildren
  '/seller': typeof SellerRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/processing': typeof AdminProcessingRoute
  '/admin/stores': typeof AdminStoresRoute
  '/admin/system-prompt': typeof AdminSystemPromptRoute
  '/admin/users': typeof AdminUsersRoute
  '/coach/system-prompt': typeof CoachSystemPromptRoute
  '/seller/analytics': typeof SellerAnalyticsRoute
  '/seller/guide': typeof SellerGuideRoute
  '/seller/upload': typeof SellerUploadRoute
  '/admin/': typeof AdminIndexRoute
  '/coach/': typeof CoachIndexRoute
  '/seller/': typeof SellerIndexRoute
  '/coach/consultations/$id': typeof CoachConsultationsIdRoute
  '/coach/sellers/$id': typeof CoachSellersIdRoute
  '/coach/stores/$id': typeof CoachStoresIdRoute
  '/seller/consultations/$id': typeof SellerConsultationsIdRoute
  '/coach/stores/': typeof CoachStoresIndexRoute
  '/seller/dashboard/': typeof SellerDashboardIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin/processing': typeof AdminProcessingRoute
  '/admin/stores': typeof AdminStoresRoute
  '/admin/system-prompt': typeof AdminSystemPromptRoute
  '/admin/users': typeof AdminUsersRoute
  '/coach/system-prompt': typeof CoachSystemPromptRoute
  '/seller/analytics': typeof SellerAnalyticsRoute
  '/seller/guide': typeof SellerGuideRoute
  '/seller/upload': typeof SellerUploadRoute
  '/admin': typeof AdminIndexRoute
  '/coach': typeof CoachIndexRoute
  '/seller': typeof SellerIndexRoute
  '/coach/consultations/$id': typeof CoachConsultationsIdRoute
  '/coach/sellers/$id': typeof CoachSellersIdRoute
  '/coach/stores/$id': typeof CoachStoresIdRoute
  '/seller/consultations/$id': typeof SellerConsultationsIdRoute
  '/coach/stores': typeof CoachStoresIndexRoute
  '/seller/dashboard': typeof SellerDashboardIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/coach': typeof CoachRouteRouteWithChildren
  '/seller': typeof SellerRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/processing': typeof AdminProcessingRoute
  '/admin/stores': typeof AdminStoresRoute
  '/admin/system-prompt': typeof AdminSystemPromptRoute
  '/admin/users': typeof AdminUsersRoute
  '/coach/system-prompt': typeof CoachSystemPromptRoute
  '/seller/analytics': typeof SellerAnalyticsRoute
  '/seller/guide': typeof SellerGuideRoute
  '/seller/upload': typeof SellerUploadRoute
  '/admin/': typeof AdminIndexRoute
  '/coach/': typeof CoachIndexRoute
  '/seller/': typeof SellerIndexRoute
  '/coach/consultations/$id': typeof CoachConsultationsIdRoute
  '/coach/sellers/$id': typeof CoachSellersIdRoute
  '/coach/stores/$id': typeof CoachStoresIdRoute
  '/seller/consultations/$id': typeof SellerConsultationsIdRoute
  '/coach/stores/': typeof CoachStoresIndexRoute
  '/seller/dashboard/': typeof SellerDashboardIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/coach'
    | '/seller'
    | '/login'
    | '/admin/processing'
    | '/admin/stores'
    | '/admin/system-prompt'
    | '/admin/users'
    | '/coach/system-prompt'
    | '/seller/analytics'
    | '/seller/guide'
    | '/seller/upload'
    | '/admin/'
    | '/coach/'
    | '/seller/'
    | '/coach/consultations/$id'
    | '/coach/sellers/$id'
    | '/coach/stores/$id'
    | '/seller/consultations/$id'
    | '/coach/stores/'
    | '/seller/dashboard/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin/processing'
    | '/admin/stores'
    | '/admin/system-prompt'
    | '/admin/users'
    | '/coach/system-prompt'
    | '/seller/analytics'
    | '/seller/guide'
    | '/seller/upload'
    | '/admin'
    | '/coach'
    | '/seller'
    | '/coach/consultations/$id'
    | '/coach/sellers/$id'
    | '/coach/stores/$id'
    | '/seller/consultations/$id'
    | '/coach/stores'
    | '/seller/dashboard'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/coach'
    | '/seller'
    | '/login'
    | '/admin/processing'
    | '/admin/stores'
    | '/admin/system-prompt'
    | '/admin/users'
    | '/coach/system-prompt'
    | '/seller/analytics'
    | '/seller/guide'
    | '/seller/upload'
    | '/admin/'
    | '/coach/'
    | '/seller/'
    | '/coach/consultations/$id'
    | '/coach/sellers/$id'
    | '/coach/stores/$id'
    | '/seller/consultations/$id'
    | '/coach/stores/'
    | '/seller/dashboard/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  CoachRouteRoute: typeof CoachRouteRouteWithChildren
  SellerRouteRoute: typeof SellerRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coach': {
      id: '/coach'
      path: '/coach'
      fullPath: '/coach'
      preLoaderRoute: typeof CoachRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seller': {
      id: '/seller'
      path: '/seller'
      fullPath: '/seller'
      preLoaderRoute: typeof SellerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/processing': {
      id: '/admin/processing'
      path: '/processing'
      fullPath: '/admin/processing'
      preLoaderRoute: typeof AdminProcessingRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/stores': {
      id: '/admin/stores'
      path: '/stores'
      fullPath: '/admin/stores'
      preLoaderRoute: typeof AdminStoresRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/system-prompt': {
      id: '/admin/system-prompt'
      path: '/system-prompt'
      fullPath: '/admin/system-prompt'
      preLoaderRoute: typeof AdminSystemPromptRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/coach/': {
      id: '/coach/'
      path: '/'
      fullPath: '/coach/'
      preLoaderRoute: typeof CoachIndexRouteImport
      parentRoute: typeof CoachRouteRoute
    }
    '/coach/system-prompt': {
      id: '/coach/system-prompt'
      path: '/system-prompt'
      fullPath: '/coach/system-prompt'
      preLoaderRoute: typeof CoachSystemPromptRouteImport
      parentRoute: typeof CoachRouteRoute
    }
    '/seller/': {
      id: '/seller/'
      path: '/'
      fullPath: '/seller/'
      preLoaderRoute: typeof SellerIndexRouteImport
      parentRoute: typeof SellerRouteRoute
    }
    '/seller/analytics': {
      id: '/seller/analytics'
      path: '/analytics'
      fullPath: '/seller/analytics'
      preLoaderRoute: typeof SellerAnalyticsRouteImport
      parentRoute: typeof SellerRouteRoute
    }
    '/seller/guide': {
      id: '/seller/guide'
      path: '/guide'
      fullPath: '/seller/guide'
      preLoaderRoute: typeof SellerGuideRouteImport
      parentRoute: typeof SellerRouteRoute
    }
    '/seller/upload': {
      id: '/seller/upload'
      path: '/upload'
      fullPath: '/seller/upload'
      preLoaderRoute: typeof SellerUploadRouteImport
      parentRoute: typeof SellerRouteRoute
    }
    '/coach/consultations/$id': {
      id: '/coach/consultations/$id'
      path: '/consultations/$id'
      fullPath: '/coach/consultations/$id'
      preLoaderRoute: typeof CoachConsultationsIdRouteImport
      parentRoute: typeof CoachRouteRoute
    }
    '/coach/sellers/$id': {
      id: '/coach/sellers/$id'
      path: '/sellers/$id'
      fullPath: '/coach/sellers/$id'
      preLoaderRoute: typeof CoachSellersIdRouteImport
      parentRoute: typeof CoachRouteRoute
    }
    '/coach/stores/': {
      id: '/coach/stores/'
      path: '/stores'
      fullPath: '/coach/stores/'
      preLoaderRoute: typeof CoachStoresIndexRouteImport
      parentRoute: typeof CoachRouteRoute
    }
    '/coach/stores/$id': {
      id: '/coach/stores/$id'
      path: '/stores/$id'
      fullPath: '/coach/stores/$id'
      preLoaderRoute: typeof CoachStoresIdRouteImport
      parentRoute: typeof CoachRouteRoute
    }
    '/seller/consultations/$id': {
      id: '/seller/consultations/$id'
      path: '/consultations/$id'
      fullPath: '/seller/consultations/$id'
      preLoaderRoute: typeof SellerConsultationsIdRouteImport
      parentRoute: typeof SellerRouteRoute
    }
    '/seller/dashboard/': {
      id: '/seller/dashboard/'
      path: '/dashboard'
      fullPath: '/seller/dashboard/'
      preLoaderRoute: typeof SellerDashboardIndexRouteImport
      parentRoute: typeof SellerRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminProcessingRoute: typeof AdminProcessingRoute
  AdminStoresRoute: typeof AdminStoresRoute
  AdminSystemPromptRoute: typeof AdminSystemPromptRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminProcessingRoute: AdminProcessingRoute,
  AdminStoresRoute: AdminStoresRoute,
  AdminSystemPromptRoute: AdminSystemPromptRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface CoachRouteRouteChildren {
  CoachSystemPromptRoute: typeof CoachSystemPromptRoute
  CoachIndexRoute: typeof CoachIndexRoute
  CoachConsultationsIdRoute: typeof CoachConsultationsIdRoute
  CoachSellersIdRoute: typeof CoachSellersIdRoute
  CoachStoresIdRoute: typeof CoachStoresIdRoute
  CoachStoresIndexRoute: typeof CoachStoresIndexRoute
}

const CoachRouteRouteChildren: CoachRouteRouteChildren = {
  CoachSystemPromptRoute: CoachSystemPromptRoute,
  CoachIndexRoute: CoachIndexRoute,
  CoachConsultationsIdRoute: CoachConsultationsIdRoute,
  CoachSellersIdRoute: CoachSellersIdRoute,
  CoachStoresIdRoute: CoachStoresIdRoute,
  CoachStoresIndexRoute: CoachStoresIndexRoute,
}

const CoachRouteRouteWithChildren = CoachRouteRoute._addFileChildren(
  CoachRouteRouteChildren,
)

interface SellerRouteRouteChildren {
  SellerAnalyticsRoute: typeof SellerAnalyticsRoute
  SellerGuideRoute: typeof SellerGuideRoute
  SellerUploadRoute: typeof SellerUploadRoute
  SellerIndexRoute: typeof SellerIndexRoute
  SellerConsultationsIdRoute: typeof SellerConsultationsIdRoute
  SellerDashboardIndexRoute: typeof SellerDashboardIndexRoute
}

const SellerRouteRouteChildren: SellerRouteRouteChildren = {
  SellerAnalyticsRoute: SellerAnalyticsRoute,
  SellerGuideRoute: SellerGuideRoute,
  SellerUploadRoute: SellerUploadRoute,
  SellerIndexRoute: SellerIndexRoute,
  SellerConsultationsIdRoute: SellerConsultationsIdRoute,
  SellerDashboardIndexRoute: SellerDashboardIndexRoute,
}

const SellerRouteRouteWithChildren = SellerRouteRoute._addFileChildren(
  SellerRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  CoachRouteRoute: CoachRouteRouteWithChildren,
  SellerRouteRoute: SellerRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
